<template lang="pug">
  e-form-group(
  :name="fieldName"
  inputType="select"
  label="Статус"
    :model="fields"
      :options="options"
      :tabView="tabView"
      :formGroupStyle="formGroupStyle"
      :required="required"
  )
</template>
<script>
import reportFieldMixin from '../../mixins/report-field-mixin'

export default {
  name: 'status',
  mixins: [reportFieldMixin],
  props: {
    options: {
      type: Array,
      default: function () {
        return [
          { id: 'active', name: 'Действующий' },
          { id: 'disabled', name: 'Не действующий' },
          { id: 'planned', name: 'Планируемый' },
        ]
      },
    },
  },
  computed: {
    fieldName() {
      if (this.name) {
        return this.name
      }
      return 'status'
    },
  },
  created() {
    this.$set(this.fields, this.fieldName, '')
  },
}
</script>
